import React, { useState } from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import HttpMethodBadge from '../../HttpMethodBadge';
import { ApiEndpoint } from '../../../utils/httpMethodColors';


const LiveStreamApiList = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = (e: { stopPropagation: () => void }) => {
        e.stopPropagation();
        setIsOpen(prev => !prev);
    };

    const liveStreamApiList: ApiEndpoint[] = [
        {
            apiName: 'Live Stream',
            navigationId: 'liveStream',
            method: 'POST'
        },
    ];

    return (
        <Box sx={{ display: 'flex', cursor: 'pointer', flexDirection: 'column', gap: 1 }} onClick={toggleAccordion}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FolderOutlinedIcon style={{ fontSize: 18 }} />
                    <Typography variant="body2" fontWeight={600} fontSize={14}>
                        Live Stream APIs
                    </Typography>
                </Box>
                <IconButton size="small" onClick={toggleAccordion}>
                    {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Box>
            {isOpen && (
                <Box pl={4} width="100%" display="flex" flexDirection="column" gap={1}>
                    {liveStreamApiList.map(api => (
                        <Box
                            key={api.navigationId}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                textDecoration: 'underline',
                                cursor: 'pointer'
                            }}
                            onClick={e => {
                                e.stopPropagation();
                                const el = document.getElementById(api.navigationId);
                                if (el) {
                                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }
                            }}
                        >
                            <HttpMethodBadge method={api.method} />
                            <Typography
                                variant="body2"
                                fontWeight={400}
                                fontSize={14}
                            >
                                {api.apiName}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};
export default LiveStreamApiList;
